import { h, r as registerInstance, f as forceUpdate, H as Host } from './index-dba4409d.js';
import { i as i18nProvider, l as loadTranslations } from './loadTranslations-46795824.js';
import { c as createStore, a as createAuthStore, S as SilentAuth } from './auth-55549ef7.js';
import { g as getEnvConfig, P as PublicApiClient, s as setEnv } from './publicApiClient-f3b890c3.js';

class ServiceDocument {
    constructor({ id, fileName, createdAt, mission }, apiClient) {
        this.store = createStore({
            isDownloading: false,
            downloadError: null,
            missionLink: null
        });
        this.objectUrl = null;
        this.id = id;
        this.fileName = fileName;
        this.createdAt = createdAt;
        this.mission = mission;
        this.apiClient = apiClient;
    }
    async download() {
        if (this.objectUrl) {
            window.open(this.objectUrl, "_blank");
            return;
        }
        try {
            this.store.state.isDownloading = true;
            this.store.state.downloadError = null;
            const response = await this.apiClient.request(`/document/downloaddocument`, {
                method: "POST",
                body: { documentId: this.id, fileName: this.fileName },
                responseType: "blob"
            });
            if (response) {
                const pdfBlob = new Blob([response], { type: "application/pdf" });
                this.objectUrl = URL.createObjectURL(pdfBlob);
                window.open(this.objectUrl, "_blank");
            }
        }
        catch (error) {
            // eslint-disable-next-line no-console
            console.log("Download error:", error);
            this.store.state.downloadError = "An error occurred while downloading the document.";
        }
        finally {
            this.store.state.isDownloading = false;
        }
    }
    makeMissionLinkable() {
        const config = getEnvConfig();
        this.store.state.missionLink = `${config.myTrumpfBaseUrl}/go/my-missions/mission/${this.mission.sisMissionId}`;
    }
    destroy() {
        if (this.objectUrl) {
            URL.revokeObjectURL(this.objectUrl);
            this.objectUrl = null;
        }
    }
}

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

var dayjs_min = {exports: {}};

(function (module, exports) {
!function(t,e){module.exports=e();}(commonjsGlobal,(function(){var t=1e3,e=6e4,n=36e5,r="millisecond",i="second",s="minute",u="hour",a="day",o="week",c="month",f="quarter",h="year",d="date",l="Invalid Date",$=/^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/,y=/\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g,M={name:"en",weekdays:"Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),months:"January_February_March_April_May_June_July_August_September_October_November_December".split("_"),ordinal:function(t){var e=["th","st","nd","rd"],n=t%100;return "["+t+(e[(n-20)%10]||e[n]||e[0])+"]"}},m=function(t,e,n){var r=String(t);return !r||r.length>=e?t:""+Array(e+1-r.length).join(n)+t},v={s:m,z:function(t){var e=-t.utcOffset(),n=Math.abs(e),r=Math.floor(n/60),i=n%60;return (e<=0?"+":"-")+m(r,2,"0")+":"+m(i,2,"0")},m:function t(e,n){if(e.date()<n.date())return -t(n,e);var r=12*(n.year()-e.year())+(n.month()-e.month()),i=e.clone().add(r,c),s=n-i<0,u=e.clone().add(r+(s?-1:1),c);return +(-(r+(n-i)/(s?i-u:u-i))||0)},a:function(t){return t<0?Math.ceil(t)||0:Math.floor(t)},p:function(t){return {M:c,y:h,w:o,d:a,D:d,h:u,m:s,s:i,ms:r,Q:f}[t]||String(t||"").toLowerCase().replace(/s$/,"")},u:function(t){return void 0===t}},g="en",D={};D[g]=M;var p="$isDayjsObject",S=function(t){return t instanceof _||!(!t||!t[p])},w=function t(e,n,r){var i;if(!e)return g;if("string"==typeof e){var s=e.toLowerCase();D[s]&&(i=s),n&&(D[s]=n,i=s);var u=e.split("-");if(!i&&u.length>1)return t(u[0])}else {var a=e.name;D[a]=e,i=a;}return !r&&i&&(g=i),i||!r&&g},O=function(t,e){if(S(t))return t.clone();var n="object"==typeof e?e:{};return n.date=t,n.args=arguments,new _(n)},b=v;b.l=w,b.i=S,b.w=function(t,e){return O(t,{locale:e.$L,utc:e.$u,x:e.$x,$offset:e.$offset})};var _=function(){function M(t){this.$L=w(t.locale,null,!0),this.parse(t),this.$x=this.$x||t.x||{},this[p]=!0;}var m=M.prototype;return m.parse=function(t){this.$d=function(t){var e=t.date,n=t.utc;if(null===e)return new Date(NaN);if(b.u(e))return new Date;if(e instanceof Date)return new Date(e);if("string"==typeof e&&!/Z$/i.test(e)){var r=e.match($);if(r){var i=r[2]-1||0,s=(r[7]||"0").substring(0,3);return n?new Date(Date.UTC(r[1],i,r[3]||1,r[4]||0,r[5]||0,r[6]||0,s)):new Date(r[1],i,r[3]||1,r[4]||0,r[5]||0,r[6]||0,s)}}return new Date(e)}(t),this.init();},m.init=function(){var t=this.$d;this.$y=t.getFullYear(),this.$M=t.getMonth(),this.$D=t.getDate(),this.$W=t.getDay(),this.$H=t.getHours(),this.$m=t.getMinutes(),this.$s=t.getSeconds(),this.$ms=t.getMilliseconds();},m.$utils=function(){return b},m.isValid=function(){return !(this.$d.toString()===l)},m.isSame=function(t,e){var n=O(t);return this.startOf(e)<=n&&n<=this.endOf(e)},m.isAfter=function(t,e){return O(t)<this.startOf(e)},m.isBefore=function(t,e){return this.endOf(e)<O(t)},m.$g=function(t,e,n){return b.u(t)?this[e]:this.set(n,t)},m.unix=function(){return Math.floor(this.valueOf()/1e3)},m.valueOf=function(){return this.$d.getTime()},m.startOf=function(t,e){var n=this,r=!!b.u(e)||e,f=b.p(t),l=function(t,e){var i=b.w(n.$u?Date.UTC(n.$y,e,t):new Date(n.$y,e,t),n);return r?i:i.endOf(a)},$=function(t,e){return b.w(n.toDate()[t].apply(n.toDate("s"),(r?[0,0,0,0]:[23,59,59,999]).slice(e)),n)},y=this.$W,M=this.$M,m=this.$D,v="set"+(this.$u?"UTC":"");switch(f){case h:return r?l(1,0):l(31,11);case c:return r?l(1,M):l(0,M+1);case o:var g=this.$locale().weekStart||0,D=(y<g?y+7:y)-g;return l(r?m-D:m+(6-D),M);case a:case d:return $(v+"Hours",0);case u:return $(v+"Minutes",1);case s:return $(v+"Seconds",2);case i:return $(v+"Milliseconds",3);default:return this.clone()}},m.endOf=function(t){return this.startOf(t,!1)},m.$set=function(t,e){var n,o=b.p(t),f="set"+(this.$u?"UTC":""),l=(n={},n[a]=f+"Date",n[d]=f+"Date",n[c]=f+"Month",n[h]=f+"FullYear",n[u]=f+"Hours",n[s]=f+"Minutes",n[i]=f+"Seconds",n[r]=f+"Milliseconds",n)[o],$=o===a?this.$D+(e-this.$W):e;if(o===c||o===h){var y=this.clone().set(d,1);y.$d[l]($),y.init(),this.$d=y.set(d,Math.min(this.$D,y.daysInMonth())).$d;}else l&&this.$d[l]($);return this.init(),this},m.set=function(t,e){return this.clone().$set(t,e)},m.get=function(t){return this[b.p(t)]()},m.add=function(r,f){var d,l=this;r=Number(r);var $=b.p(f),y=function(t){var e=O(l);return b.w(e.date(e.date()+Math.round(t*r)),l)};if($===c)return this.set(c,this.$M+r);if($===h)return this.set(h,this.$y+r);if($===a)return y(1);if($===o)return y(7);var M=(d={},d[s]=e,d[u]=n,d[i]=t,d)[$]||1,m=this.$d.getTime()+r*M;return b.w(m,this)},m.subtract=function(t,e){return this.add(-1*t,e)},m.format=function(t){var e=this,n=this.$locale();if(!this.isValid())return n.invalidDate||l;var r=t||"YYYY-MM-DDTHH:mm:ssZ",i=b.z(this),s=this.$H,u=this.$m,a=this.$M,o=n.weekdays,c=n.months,f=n.meridiem,h=function(t,n,i,s){return t&&(t[n]||t(e,r))||i[n].slice(0,s)},d=function(t){return b.s(s%12||12,t,"0")},$=f||function(t,e,n){var r=t<12?"AM":"PM";return n?r.toLowerCase():r};return r.replace(y,(function(t,r){return r||function(t){switch(t){case"YY":return String(e.$y).slice(-2);case"YYYY":return b.s(e.$y,4,"0");case"M":return a+1;case"MM":return b.s(a+1,2,"0");case"MMM":return h(n.monthsShort,a,c,3);case"MMMM":return h(c,a);case"D":return e.$D;case"DD":return b.s(e.$D,2,"0");case"d":return String(e.$W);case"dd":return h(n.weekdaysMin,e.$W,o,2);case"ddd":return h(n.weekdaysShort,e.$W,o,3);case"dddd":return o[e.$W];case"H":return String(s);case"HH":return b.s(s,2,"0");case"h":return d(1);case"hh":return d(2);case"a":return $(s,u,!0);case"A":return $(s,u,!1);case"m":return String(u);case"mm":return b.s(u,2,"0");case"s":return String(e.$s);case"ss":return b.s(e.$s,2,"0");case"SSS":return b.s(e.$ms,3,"0");case"Z":return i}return null}(t)||i.replace(":","")}))},m.utcOffset=function(){return 15*-Math.round(this.$d.getTimezoneOffset()/15)},m.diff=function(r,d,l){var $,y=this,M=b.p(d),m=O(r),v=(m.utcOffset()-this.utcOffset())*e,g=this-m,D=function(){return b.m(y,m)};switch(M){case h:$=D()/12;break;case c:$=D();break;case f:$=D()/3;break;case o:$=(g-v)/6048e5;break;case a:$=(g-v)/864e5;break;case u:$=g/n;break;case s:$=g/e;break;case i:$=g/t;break;default:$=g;}return l?$:b.a($)},m.daysInMonth=function(){return this.endOf(c).$D},m.$locale=function(){return D[this.$L]},m.locale=function(t,e){if(!t)return this.$L;var n=this.clone(),r=w(t,e,!0);return r&&(n.$L=r),n},m.clone=function(){return b.w(this.$d,this)},m.toDate=function(){return new Date(this.valueOf())},m.toJSON=function(){return this.isValid()?this.toISOString():null},m.toISOString=function(){return this.$d.toISOString()},m.toString=function(){return this.$d.toUTCString()},M}(),k=_.prototype;return O.prototype=k,[["$ms",r],["$s",i],["$m",s],["$H",u],["$W",a],["$M",c],["$y",h],["$D",d]].forEach((function(t){k[t[1]]=function(e){return this.$g(e,t[0],t[1])};})),O.extend=function(t,e){return t.$i||(t(e,_,O),t.$i=!0),O},O.locale=w,O.isDayjs=S,O.unix=function(t){return O(1e3*t)},O.en=D[g],O.Ls=D,O.p={},O}));
}(dayjs_min));

const dayjs = dayjs_min.exports;

class Documents {
    constructor(config, tokenReady = () => { }) {
        this.store = createStore({
            documents: null,
            isLoading: true,
            error: null,
            minDate: null,
            maxDate: null,
            filters: {
                assignmentTypes: null,
                startDate: null,
                endDate: null
            }
        });
        this.apiClient = new PublicApiClient(config);
        this.apiClient.subscribeToTbdbToken(() => tokenReady());
    }
    getFilteredDocuments(documents = null) {
        if (!documents) {
            return null;
        }
        const { filters } = this.store.state;
        return documents.filter((doc) => {
            if (!filters.assignmentTypes || filters.assignmentTypes.includes(doc.mission.assignmentType)) {
                const startDate = filters.startDate ? new Date(filters.startDate) : null;
                const endDate = filters.endDate ? new Date(filters.endDate) : null;
                const createdAt = new Date(doc.createdAt);
                if (startDate && dayjs(createdAt).isBefore(startDate, "day")) {
                    return false;
                }
                if (endDate && dayjs(createdAt).isAfter(endDate, "day")) {
                    return false;
                }
                return true;
            }
            return false;
        });
    }
    async getDocumentsForMission(missionNumber) {
        await this.getDocuments(`/document/getdocumentsformission`, { missionNumber });
    }
    async getDocumentsForMachine(machineNumber) {
        await this.getDocuments(`/document/getdocumentsformachine`, { machineNumber });
        try {
            const linkableMissions = await this.getLinkableMissions();
            this.addLinksToDocuments(linkableMissions);
        }
        catch (error) {
            // eslint-disable-next-line no-console
            console.error("Error fetching linkable missions:", error);
        }
    }
    addLinksToDocuments(linkableMissions) {
        if (linkableMissions.length === 0) {
            return;
        }
        const linkableMissionNumbers = linkableMissions.map((mission) => mission.missionNumber);
        const { documents } = this.store.state;
        documents === null || documents === void 0 ? void 0 : documents.forEach((doc) => {
            if (linkableMissionNumbers.includes(doc.mission.sisMissionId)) {
                doc.makeMissionLinkable();
            }
        });
    }
    async getDocuments(url, body) {
        try {
            const response = await this.apiClient.request(url, { body });
            this.store.state.documents = response.map((docData) => new ServiceDocument(docData, this.apiClient));
            this.calculateMinMaxDates();
            this.store.state.error = null;
        }
        catch (error) {
            // eslint-disable-next-line no-console
            console.error("Error fetching documents:", error);
            this.store.state.error = "An error occurred while fetching documents.";
        }
        finally {
            this.store.state.isLoading = false;
        }
    }
    // not all missions are available on myTrumpf to link to, thats why we need to fetch available missions
    async getLinkableMissions() {
        return this.apiClient.request("/appointment/findmissionitems", {});
    }
    calculateMinMaxDates() {
        const { documents } = this.store.state;
        if (!documents || documents.length === 0) {
            this.store.state.minDate = null;
            this.store.state.maxDate = null;
            return;
        }
        const dates = documents.map((doc) => new Date(doc.createdAt).getTime());
        this.store.state.minDate = new Date(Math.min(...dates)).toISOString().split("T")[0];
        this.store.state.maxDate = new Date(Math.max(...dates)).toISOString().split("T")[0];
    }
}

const ReportItem = ({ t, document, title, isOnMachinePage = false, machineNumber, machineAlias, machineName, technicianName }) => {
    return (h("div", { class: "mf-service-reports__report-item", key: document.id },
        title && h("h3", { class: "ux-text-title ux-text-title--light" }, title),
        h("div", { class: "ux-row" },
            !isOnMachinePage && machineNumber && (h(ReportData, { label: t("mf-service-calls:serviceReports.machineNameAndNumber") },
                h("strong", null, machineAlias),
                " ",
                machineName,
                " - ",
                machineNumber)),
            !isOnMachinePage && technicianName && (h(ReportData, { label: t("mf-service-calls:serviceReports.technicianName") }, technicianName)),
            h(ReportData, { label: t("mf-service-calls:serviceReports.creationDate") },
                h("ux-date-time", { class: "ux-date-time hydrated", utc: document.createdAt, format: "DD.MM.YYYY HH:mm" })),
            isOnMachinePage && (h(ReportData, { label: t("mf-service-calls:serviceReports.missionNumber") },
                h(MissionLink, { document: document }))),
            h("div", { class: "mf-service-reports__report-spacer" }),
            h(DownloadButton, { t: t, document: document }))));
};
const ReportData = ({ label }, children) => {
    return (h("div", { class: "ux-u-mr-xxs ux-col-12 ux-col-lg-auto ux-u-mt-xxs", key: label },
        h("span", { class: "ux-u-d-block ux-text-tiny ux-text-tiny--bold ux-u-text-uppercase" }, label),
        h("span", { class: "ux-u-d-block ux-text-normal" }, children)));
};
const DownloadButton = ({ t, document }) => {
    const { isDownloading, downloadError } = document.store.state;
    return (h("div", { class: "ux-u-ml-xl-auto ux-col-12 ux-col-lg-auto ux-u-mt-xxs ux-u-flex-ai-end ux-u-flex-as-end ux-u-flex-dir-column ux-u-d-flex" },
        h("ux-button", { icon: "download", iconPlacement: "end", disabled: isDownloading, onClick: () => document.download() }, isDownloading ? (h("ux-loader", { style: {
                minWidth: "100px"
            } })) : (t("mf-service-calls:serviceReports.openReport"))),
        downloadError && h("div", { class: "error" }, downloadError)));
};
const MissionLink = ({ document }) => {
    const { missionLink } = document.store.state;
    if (!missionLink) {
        return document.mission.sisMissionId;
    }
    return (h("a", { href: missionLink, class: "ux-text-link ux-text-link--primary", target: "_blank" },
        document.mission.sisMissionId,
        " ",
        h("ux-icon", { name: "arrow-right" })));
};

function getGroupedDocuments(documents) {
    return ((documents === null || documents === void 0 ? void 0 : documents.reduce((acc, doc) => {
        const key = doc.mission.assignmentType;
        if (!acc[key]) {
            acc[key] = [];
        }
        acc[key].push(doc);
        return acc;
    }, {})) || {});
}
const GroupedReports = ({ t, documents, filteredDocuments, isOnMachinePage, machineNumber, machineAlias, machineName, technicianName }) => {
    if (!documents || !filteredDocuments) {
        return null;
    }
    if (documents.length === 0) {
        return h("div", { class: "ux-u-text-align--center ux-text-normal" }, t("mf-service-calls:serviceReports.noReportsAvailable"));
    }
    if (filteredDocuments.length === 0) {
        return h("div", { class: "ux-u-text-align--center ux-text-normal" }, t("mf-service-calls:serviceReports.noReportsFound"));
    }
    const groupedDocuments = getGroupedDocuments(filteredDocuments);
    if (!isOnMachinePage) {
        return (h("div", null, filteredDocuments.map((doc) => (h(ReportItem, { t: t, document: doc, machineNumber: machineNumber, machineAlias: machineAlias, machineName: machineName, technicianName: technicianName })))));
    }
    return (h("div", null, Object.keys(groupedDocuments).map((missionType, i) => {
        const amount = groupedDocuments[missionType].length;
        return (h("ux-accordion", { key: missionType, isExpanded: i === 0 },
            h("span", { slot: "title", class: "ux-text-title ux-text-title--light" },
                t(getReportGroupTranslationKey(missionType, amount)),
                " (",
                amount,
                ")"),
            groupedDocuments[missionType].map((doc) => (h("div", { class: "ux-info-box" },
                h(ReportItem, { t: t, document: doc, title: t(`mf-service-calls:serviceReports.reportTypes.${missionType}`), isOnMachinePage: true }))))));
    })));
};
const getReportGroupTranslationKey = (missionType, amount) => {
    const singularKey = `mf-service-calls:serviceReports.reportTypes.${missionType}`;
    const pluralKey = `mf-service-calls:serviceReports.reportTypesPlural.${missionType}`;
    return amount === 1 ? singularKey : pluralKey;
};

const reportTypes = [
    "RP",
    "RW",
    "WA",
    "IA",
    "AC",
    "IV",
    "BA",
    "UV",
    "IG",
    "UB",
    "PN",
    "NR",
    "IB",
    "II",
    "IC",
    "MB",
    "HW",
    "TT",
    "SK"
];

const Filter = ({ t, handleFilterChange, minDate, maxDate, documents }) => {
    if (!minDate || !maxDate || !documents || documents.length === 1) {
        return null;
    }
    const hasDifferentDates = !dayjs(minDate).isSame(maxDate, "day");
    const hasDifferentAssignmentTypes = documents.some((doc) => doc.mission.assignmentType !== documents[0].mission.assignmentType);
    if (!hasDifferentDates && !hasDifferentAssignmentTypes) {
        return null;
    }
    const isTypeInDocuments = (type) => {
        var _a;
        return (_a = documents === null || documents === void 0 ? void 0 : documents.some((doc) => doc.mission.assignmentType === type)) !== null && _a !== void 0 ? _a : false;
    };
    const getValues = () => {
        const startInput = document.querySelector(".mf-service-reports__filter input[name='start_date']");
        const endInput = document.querySelector(".mf-service-reports__filter input[name='end_date']");
        const checkedAssignmentTypeInputs = document.querySelectorAll(".mf-service-reports__filter input[name='assignmentType']:checked");
        return {
            startDate: startInput ? startInput.value : null,
            endDate: endInput ? endInput.value : null,
            assignmentTypes: checkedAssignmentTypeInputs.length > 0 ? Array.from(checkedAssignmentTypeInputs).map((input) => input.value) : null
        };
    };
    const handleChange = () => {
        setTimeout(() => handleFilterChange(getValues()), 100);
    };
    return (h("div", { class: "mf-service-reports__filter ux-u-mb-xs" },
        h("ux-filter", null,
            h("fieldset", null,
                h("legend", { class: "ux-label" }, t("mf-service-calls:serviceReports.creationDate")),
                h("ux-date-range-picker", { "range-start-label": t("mf-service-calls:serviceReports.startDate"), "range-start-value": minDate, "range-end-label": t("mf-service-calls:serviceReports.endDate"), "range-end-value": maxDate, "date-format": t("mf-service-calls:dateFormat"), "min-date": minDate, "max-date": maxDate, onUxDateRangeChange: handleChange, todayText: t("widget.filter.period.option.today"), resetText: t("general.resetButton") })),
            h("fieldset", null,
                h("legend", { class: "ux-label" }, t("mf-service-calls:serviceReports.filter")),
                h("ux-dropdown", { placeholder: t("mf-service-calls:serviceReports.assignmentType") }, reportTypes.map((type) => (h("ux-checkbox-list-item", { name: "assignmentType", value: type, key: type, disabled: !isTypeInDocuments(type), onUxCheckboxListItemChange: handleChange }, t(`mf-service-calls:serviceReports.assignmentTypes.${type}`)))))))));
};

const serviceReportsScss = ".mf-service-reports ux-accordion[is-expanded] [slot=\"title\"]{color:var(--ux-color-primary)}.mf-service-reports .ux-filter fieldset{border:0;padding:0;margin:0 0 15px;display:inline-block}.mf-service-reports ux-date-range-picker{margin-right:20px}.mf-service-reports .ux-dropdown{min-width:248px}.mf-service-reports .ux-info-box{margin-bottom:20px}.mf-service-reports__report-item .ux-text-title{margin-bottom:0}.mf-service-reports .mf-service-reports__report-spacer{flex-grow:1;width:auto}.mf-service-reports__error{color:#ff0201}";
const MfServiceReportsStyle0 = serviceReportsScss;

const ServiceReports = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.authStore = createAuthStore();
        this.handleFilterChange = (filters) => {
            this.documents.store.state.filters = filters;
        };
        this.machineNumber = undefined;
        this.missionNumber = undefined;
        this.locale = "en-US";
        this.env = undefined;
        this.legacyApi = false;
        this.technicianName = undefined;
        this.machineAlias = undefined;
        this.machineName = undefined;
        this.hideFilter = false;
    }
    componentWillLoad() {
        setEnv(`${this.env}${this.legacyApi ? "Legacy" : ""}`);
        this.config = getEnvConfig();
        this.documents = new Documents(this.config, () => this.onTokenReady());
    }
    connectedCallback() {
        this.i18nSubscriberId = i18nProvider.subscribe(() => forceUpdate(this));
        this.loadTranslations();
    }
    onLocaleChange() {
        if (this.locale !== i18nProvider.language) {
            this.loadTranslations();
        }
    }
    loadTranslations() {
        loadTranslations(this.locale).then((locale) => {
            i18nProvider.changeLanguage(locale);
            this.locale = locale;
        });
    }
    disconnectedCallback() {
        const { documents } = this.documents.store.state;
        documents === null || documents === void 0 ? void 0 : documents.forEach((doc) => doc.destroy());
        i18nProvider.unsubscribe(this.i18nSubscriberId);
    }
    async onTokenReady() {
        if (this.missionNumber) {
            await this.documents.getDocumentsForMission(this.missionNumber);
        }
        else if (this.machineNumber) {
            await this.documents.getDocumentsForMachine(this.machineNumber);
        }
    }
    render() {
        const { isLoading, error, documents, maxDate, minDate } = this.documents.store.state;
        const { t } = i18nProvider;
        const isOnMachinePage = !!this.machineNumber && !this.missionNumber;
        return (h(Host, { key: '3c2be3389113021c08197777af8f6a50dc3e685a', class: "mf-service-reports" }, h("h2", { key: '4f02b4a925b5459e4e0e3b387c1b2a3341c64fc4', class: "ux-text-headline ux-text-headline--big ux-u-text-align--center" }, t("mf-service-calls:serviceReports.headline")), isOnMachinePage && h("p", { key: '49b2a6a6493b50c260f27c30a1f128944a4d7657', class: "ux-text-normal" }, t("mf-service-calls:serviceReports.sublineMachine")), !this.hideFilter && (h(Filter, { key: '3bb88693d89d8f490cff923d1da72e67d91fc53d', handleFilterChange: this.handleFilterChange, t: t, minDate: minDate, maxDate: maxDate, documents: documents })), h(GroupedReports, { key: 'ca715d3e05704d92fd776d7abb68645fd955452d', t: t, documents: documents, filteredDocuments: this.documents.getFilteredDocuments(documents), isOnMachinePage: isOnMachinePage, machineNumber: this.machineNumber, machineAlias: this.machineAlias, machineName: this.machineName, technicianName: this.technicianName }), isLoading && h("ux-loader", { key: 'e7fa788d7d1c79e323087778a338737ec75b52dd', variant: "spinner" }), error && (h("div", { key: '67a4198c5c57e99fb73584214c50ca9218659e8a', class: "mf-service-reports__error ux-text-normal" }, t("mf-service-calls:serviceReports.loadError"), ": ", error)), h(SilentAuth, { key: '79a874d4850371f755cf4ed899d82ffb3eb601a7', disabled: false, config: this.config, authStore: this.authStore })));
    }
    static get watchers() { return {
        "locale": ["onLocaleChange"]
    }; }
};
ServiceReports.style = MfServiceReportsStyle0;

export { ServiceReports as mf_service_reports };

//# sourceMappingURL=mf-service-reports.entry.js.map